<template>
  <div class="advanced-search-form">
    <div class="builder">
      <div v-for="(row, index) in rows" :key="row.id" class="search-row">
        <div class="is-valid-row pull-right">
          <i class="fa fa-times invalid" v-if="!isRowValid(row)"></i>
          <i class="fa fa-check valid" v-if="isRowValid(row)"></i>
        </div>

        <div v-if="index === 0">
          <span class="describe">I want to find interactions for</span>
          <time-range-select
            :selectedRange="range"
            @onRangeChanged="updateRange($event)"
            @onDateRangeSelected="updateDateRangeInput($event)"
          />
          <span class="describe">where</span>
          <search-field-select
            :fields="searchFields"
            :selectedField="row.field"
            :selectedOperator="row.operator"
            :selectedInput="row.input"
            @onFieldsChanged="updateRowData(row.id, $event)"
          />
          <span class="describe" v-if="showPicker">Range</span>
          <el-date-picker
            style="width: 20%"
            start-placeholder="Start"
            end-placeholder="End"
            type="datetimerange"
            range-separator="-"
            v-model="dateRange"
            v-if="showPicker"
          ></el-date-picker>
        </div>

        <div v-if="index >= 1">
          <el-select v-model="searchType" placeholder="Please select" v-if="index === 1">
            <el-option
              v-for="currentType in searchTypes"
              :key="currentType.id"
              :label="currentType.value"
              :value="currentType.id"
            />
          </el-select>

          <span class="describe" v-if="index > 1">{{ searchType }}</span>

          <search-field-select
            :fields="searchFields"
            :selectedField="row.field"
            :selectedOperator="row.operator"
            :selectedInput="row.input"
            @onFieldsChanged="updateRowData(row.id, $event)"
          />

          <el-button style="margin-top: 1px;" type="default" @click="removeRow(index)">
            <i class="fa fa-trash"></i>
          </el-button>
        </div>
      </div>
    </div>
    <div class="controls">
      <el-button type="default" @click="addRow()">
        <i class="fa fa-plus"></i>
      </el-button>

      <div class="pull-right">
        <el-button type="primary" @click="search()" :disabled="!isAllRowsValid(rows)">
          <i class="fa fa-search"></i> Search
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import TimeRangeSelect from './TimeRangeSelect';
import SearchFieldSelect from './SearchFieldSelect';

const randString = (length = 10) =>
  Math.round(36 ** (length + 1) - Math.random() * 36 ** length)
    .toString(36)
    .slice(1);

export default {
  components: {
    TimeRangeSelect,
    SearchFieldSelect,
  },

  computed: {
    dateRange: {
      get() {
        return this.dates;
      },
      set(dateRange) {
        const datesOne = {
          start: dateRange[0].toISOString(),
          end: dateRange[1].toISOString(),
        };
        this.dates = dateRange;
        this.updateRange(datesOne);
      },
    },
  },

  props: {
    searchFields: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    searchTypes: [{ id: 'and', value: 'and' }, { id: 'or', value: 'or' }],
    range: null,
    searchType: 'and',
    rows: [],
    showPicker: false,
    dates: [],
  }),

  mounted() {
    this.addRow();
  },

  methods: {
    addRow() {
      const id = randString();
      this.rows = [...this.rows, { field: null, operator: null, input: null, id }];
    },
    removeRow(rowIndex) {
      this.rows = this.rows.filter((row, index) => index !== rowIndex);
    },

    updateRowData(id, data) {
      this.rows = this.rows.map(x => (x.id === id ? { ...data, id } : x));
    },
    updateDateRangeInput(show) {
      this.showPicker = show;
    },
    updateRange(range) {
      this.range = range;
      this.$forceUpdate();
    },
    buildQuery() {
      const rangeQuery = this.range
        ? [{ field: 'date_created', match: 'date_range', value: this.range }]
        : [];

      return {
        [this.searchType]: [
          ...rangeQuery,
          ...this.rows.map(row => ({
            field: row.field,
            match: row.operator,
            value: row.input,
          })),
        ],
      };
    },

    /**
     * Validates a row.
     * @param {Object} rowData - Row data with keys of field, match, value
     * @returns {boolean}
     */
    isRowValid(rowData) {
      return Boolean(
        rowData.field && rowData.operator && (rowData.input || rowData.operator === 'exists'),
      );
    },

    /**
     * Validates a collection of rows.
     * @param {Array} - Collection of row data with keys of field, match, value
     * @returns {boolean}
     */
    isAllRowsValid(rowsData) {
      return rowsData.every(this.isRowValid);
    },
    search() {
      this.$emit('onSearch', this.buildQuery());
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/style/_variables_live.scss';

.builder {
  background: #f9f9f9;
  padding: 10px;
}

.controls {
  margin: 15px 0;
}

.search-row {
  margin: 10px;
}

.describe {
  font-size: 1.3em;
}

.valid {
  color: $colony-green;
}

.invalid {
  color: $colony-red;
}
</style>



// WEBPACK FOOTER //
// AdvancedSearchForm.vue?71676eb3